window.dn = window.dn || {};

/** All methods related to search. */
(function (search, $, undefined)
{
    var done = false;
    var currentPage = 0;
    var numPageLoads = 0;
    var maxPageLoads = 50;  // don't let us call "loadMore" more than this

    /**
     * The aggregations we want to show, in the order we want to show them. 
     * These also need to be defined in Constants.EngineSearchAggregations.
     */
    search.Aggregations =
    [
        {
            Name: "Source",
            Type: "SourceKey",
            TypeShort: "src",
            IsArray: true,
            MaxSize: 5,
            Filter: function() { return true; }, // no filter
            Sort: function(a, b)
            {
                // Sort by the make name
                return a.localeCompare(b);
            },
            ValueLookup: function(value) 
            { 
                // Wrap the return value in a span that doesn't wrap
                return value;
            }
        },
        {
            Name: "Category",
            Type: "Category",
            TypeShort: "cat",
            IsArray: true,
            MaxSize: 20, // best guess for now
            Filter: function() { return true; }, // no filter
            Sort: function(a, b)
            {
                // Sort by the make name
                return a.localeCompare(b);
            },
            ValueLookup: function(value) 
            { 
                // Wrap the return value in a span that doesn't wrap
                return value;
            }
        },
        {
            Name: "Topic",
            Type: "Topics",
            TypeShort: "tpc",
            IsArray: true,
            MaxSize: 20, // best guess for now
            Filter: function() { return true; }, // no filter
            Sort: function(a, b)
            {
                // Sort by the make name
                return a.localeCompare(b);
            },
            ValueLookup: function(value) 
            { 
                // Wrap the return value in a span that doesn't wrap
                return value;
            }
        },
        // {
        //     Name: "Discussion Type",
        //     Type: "CommunityTypeId",
        //     TypeShort: "cty",
        //     IsArray: true,
        //     MaxSize: 5,
        //     Filter: function() { return true; }, // no filter
        //     Sort: function(a, b)
        //     {
        //         // Sort by the name of the discussion type
        //         return dn.constants.DiscussionTypes[a].NamePluralized.localeCompare(dn.constants.DiscussionTypes[b].NamePluralized);
        //     },
        //     ValueLookup: function(value) { return dn.constants.DiscussionTypes[value].NamePluralized; }
        // },
        {
            Name: "Status",
            Type: "Status",
            TypeShort: "st",
            IsArray: true,
            MaxSize: 5,
            Filter: function() { return true; }, // no filter
            Sort: function(a, b)
            {
                // Sort by the name of the discussion type
                return dn.message.StatusVerbs[a].localeCompare(dn.message.StatusVerbs[b]);
            },
            ValueLookup: function(value) { return dn.message.StatusVerbs[value]; }
        },
        // {
        //     Name: "Topic / Group",
        //     Type: "CommunityTopics",
        //     TypeShort: "cto",
        //     IsArray: true,
        //     MaxSize: 5,
        //     Filter: function(topicId) { return dn.constants.Topics.hasOwnProperty(topicId); },
        //     Sort: function(a, b)
        //     {
        //         // Sort by topic Type, and then NameShort
        //         var topicA = dn.constants.Topics[a];
        //         var topicB = dn.constants.Topics[b];

        //         if (topicA.Type != topicB.Type)
        //         {
        //             return topicA.Type - topicB.Type;
        //         }

        //         return topicA.NameShort.localeCompare(topicB.NameShort);
        //     },
        //     ValueLookup: function(value) { return dn.constants.Topics[value].NameShort; }
        // },
        {
            Name: "Make",
            Type: "Make",
            TypeShort: "mk",
            IsArray: true,
            MaxSize: 5,
            Filter: function() { return true; }, // no filter
            Sort: function(a, b)
            {
                // Sort by the make name
                return a.localeCompare(b);
            },
            ValueLookup: function(value) { return value; }
        }
        //,{
        //     Name: "Engine Family",
        //     Type: "EngineDesignation",
        //     TypeShort: "eng",
        //     IsArray: true,
        //     MaxSize: 5,
        //     Filter: function() { return true; }, // no filter
        //     Sort: function(a, b)
        //     {
        //         // Sort by the engine designation
        //         return a.localeCompare(b);
        //     },
        //     ValueLookup: function(value) { return value; }
        // },
        // {
        //     Name: "DTCs",
        //     Type: "TroubleCodes",
        //     TypeShort: "dtc",
        //     IsArray: true,
        //     MaxSize: 5,
        //     Filter: function() { return true; }, // no filter
        //     Sort: function(a, b)
        //     {
        //         // Sort by the engine designation
        //         return a.localeCompare(b);
        //     },
        //     ValueLookup: function(value) { return value; }
        // },
        // {
        //     Name: "Body Codes",
        //     Type: "BodyCodes",
        //     TypeShort: "bod",
        //     IsArray: true,
        //     MaxSize: 5,
        //     Filter: function() { return true; }, // no filter
        //     Sort: function(a, b)
        //     {
        //         // Sort by the engine designation
        //         return a.localeCompare(b);
        //     },
        //     ValueLookup: function(value) { return value; }
        // }
    ];

    /** Internal search error codes */
    search.Error = 
    {
        LoadingItems:   1,
        NoItems:        2,
        RenderingItem:  3,
        SearchPlatformError: 4
    };

    /**
     * This will be set to true if the viewer has MANUALLY disabled VX suggestions for this search.
     * This is a signal to our code that we should show them the tag box to ask them why they disabled it.
     */
    search.DisabledVX = false;

    /**
     * Will be `true` if the results on screen are a mix of accessible and inaccessible items.
     * For example, if an unpaid subscriber is part of a special group that allows all of its 
     * subscribers to access the content, then there could be a mix of accessible and inaccessible
     * search results. In that situation, we're going to highlight the ones they _can_ access.
     */
    search.IsMixedAccessibility = false;

    /**
     * Set to true when the user is currently searching. If this is true, it will effect 
     * the UI so that the search interface is taking up most of the screen real estate.
     */
    search.IsSearching = false;

    /** 
     * Used to store any keywords being searched.
     * 
     * TODO: Should we just track this state in the search.Vue.SearchRequest?
     */
    search.Keywords = "";

    /**
     * Total number of results for current search keywords.
     */
    search.NumHits = 0;

    /**
     * This will hold our current querystring once constructed in search.Vue.setSearchRequest().
     */
    search.QueryString = null;

    /**
     * Current Vue object for search.
     */
    search.Vue = {};

    /**
     * Called when the user clicks on the "X More..." link for an aggregation. This will expand the
     * aggregation to show all of the choices, and will change the link text to "Collapse...".
     */
    search.AggregationExpand = function(e)
    {
        var $clickedElement = $(this);
        var $parentDiv = $clickedElement.closest('.dn-search-agg');
        
        if ($parentDiv.hasClass("dn-agg-collapsed"))
        {
            // Expand all controls and change the link text to "Show Fewer..."
            $parentDiv.find('.custom-control').addClass("dn-show-control");
            $parentDiv.addClass("dn-agg-expanded").removeClass("dn-agg-collapsed");
            $clickedElement.hide();
        }
        else
        {
            // Collapse all controls and change the link text to "X More..."
            $parentDiv.find('.custom-control:gt(' + ($parentDiv.data('max-size') - 1) + ')').removeClass("dn-show-control");
            $parentDiv.addClass("dn-agg-collapsed").removeClass("dn-agg-expanded");
            $clickedElement.show();
        }
    };

    /**
     * Returns true if the current view is showing search results, false otherwise.
     */
    search.HasResults = function()
    {
        return (history.state && history.state.SearchResult && history.state.SearchResult.Hits.length > 0);
    }

    /**
     * Initialization code called only from pages that actually need to use it.
     */
    search.Init = function()
    {
        console.debug("search.Init");

        $("body").addClass("dn-search-mode dn-search-page" + (dn.IsTouchDevice ? " dn-touch-device" : ""));
        $("#dn-nav-bar").addClass("sticky-top");

        search.IsSearching = true;
        search.Keywords = (dn.QueryString.q || dn.QueryString.k || null);

        window.addEventListener('popstate', function(event) 
        {
            console.debug("popstate", window.location.search, event);

            if (event.state && event.state.SearchResult)
            {
                search.Vue.clear();

                // Reconstitute our state
                search.Keywords = event.state.Keywords;
                search.QueryString = window.location.search;
                search.Vue.SearchRequest = event.state.SearchRequest;
                search.NumHits = event.state.SearchResult.Hits.length;

                $("#dn-search").val(search.Keywords || "");

                // Re-render our search results from history
                console.debug("popstate", "Re-rendering", event.state);
                search.Vue.processSearchResult(event.state.SearchResult);
            }
        });

        $("#dn-search-filters-expand").on('click', function(e)
        {
            $("#dn-search-tools").removeClass("collapsed");
        });

        $("#dn-search-filters-collapse").on('click', function(e)
        {
            $("#dn-search-tools").addClass("collapsed");
        });

        $("#dn-vx-ignore").change(function() 
        {
            if (this.checked) 
            {
                // Make sure the text isn't dim since it's now enabled
                $("#dn-vx-description").css("opacity", 1.0);
                search.DisabledVX = false;
            } 
            else 
            {
                // Dim the text so it's clear it's been disabled
                $("#dn-vx-description").css("opacity", 0.6);
                search.DisabledVX = true;
            }

            // Update our search, which will infer the change to the VX preference
            search.Vue.fetch(true); // deferToCheckboxes == true, ignore querystring when deciding which filters to apply
        });

        $("#dn-vx-feedback").on('click', function(e)
        {
            dn.tag.ShowTagger
            ({
                $element: $(this), 
                tagEvent: dn.tag.TagEvent.IgnoreVX,
                labelSave: 'Send',
                title: 'Reason for ignoring suggested vehicle' + (($("span.dn-search-vehicles div.dn-metadata").length == 1) ? '?' : 's?'),
                onSaveTag: dn.search.SendFeedback,
                onSaveTagSuccess: function(tagResult) { console.debug("onSaveTagSuccess", tagResult); },
                onClose: function()
                {
                    // TODO: Record the VX/Ignored event in the database, with no tags
                }
            });
        });

        // Handle device rotation events for certain things, like automatically showing the search
        // filters when someone rotates to landscape mode after seeing the search results.
        dn.HandleRotations
        ({
            onLandscape: function()
            {
                if ($("#dn-search-tools").hasClass("collapsed") && search.HasResults())
                {
                    console.debug("onLandscape", "Showing search filters due to rotation to landscape.");
                    $("#dn-search-tools").removeClass("collapsed");
                }
            }
        });

        search.Vue = new Vue
        (
            {
                el: '#dn-search-results',
                data: 
                {
                    Hits: [],
                    SearchRequest: {},
                    busy: false
                },
                beforeCreate: function() 
                {
                    // Replace our data-v-infinite-scroll attribute with the non-standard Vue plugin attribute, "v-infinite-scroll".
                    // We are only doing this to pass W3C validation. Once custom attributes are acceptable, we can just use it directly.
                    $('div[data-v-infinite-scroll]').each(function() 
                    {
                        $(this).attr('v-infinite-scroll', $(this).data('v-infinite-scroll'));
                        $(this).removeAttr('data-v-infinite-scroll');
                    });

                    // Add in vue v-bind directives that W3C normally complains about, due to the colon not being XML compliant for attributes
                    $('search-result').attr(":result", "result").attr(":vue-index", "index").attr(":key", "result.Source.DocumentKey");
                },
                updated: function () 
                {
                    this.$nextTick(function () 
                    {
                        // Code that will run only after the entire view has been re-rendered

                        // Wire up any new tooltips that have appeared, then remove the data-toggle attribute so we don't 
                        // call tooltip() on these elements again. The additional 'svg' filter is because font awesome icons
                        // tend to inherit attributes on the <i> tags, which if they're tooltips, can cause double-rendering issues.
                        $("#dn-search-results [data-toggle=tooltip]:not(svg)").tooltip(
                        {
                            container: '#dn-search-results',
                            sanitize: false,
                            sanitizeFn: function (content) {return content;}
                        })
                        .removeAttr('data-toggle');

                        // add click-handlers to the visible attachments
                        $("div.dn-file-wrapper:not(.dn-event-click)").click(function(e) 
                        {
                            e.preventDefault();     // don't let the default event happen
                            e.stopPropagation();    // don't let this bubble up

                            $searchResult = $(this).parents("div.dn-search-result");

                            // Get an array of the required badges from the data-required-badges attribute
                            var requiredBadges = String($searchResult.data('required-badges') || '')   // guarantee we’re working with text
                            .split(',')                      // "1,2,3" → ["1","2","3"]
                            .filter(function (token) 
                            {       // drop empty pieces *and* non‑digits
                                return /^\d+$/.test(token);    // keep only tokens that are all digits
                            })
                            .map(function (token) 
                            {          // convert to integers
                                return parseInt(token, 10);
                            });

                            var missingBadges = dn.user.GetMissingBadges(requiredBadges);

                            // Check to see if the user has all the required badges
                            if (missingBadges.length > 0)
                            {
                                dn.ShowBadgeModal(missingBadges, "to view this discussion", "", $searchResult.hasClass("dn-search-result accessible") ? "" : "<blockquote><b>NOTE:</b> You will need a <a href=\"/billing\">Premium subscription</a> to see this search result, regardless of whether you earn this badge.</blockquote>");
                            }
                            else if ($searchResult.hasClass("not-accessible"))
                            {
                                // This is a message that is inaccessible from a search result
                                dn.PromptToUpgrade("CanSearch");
                            }
                            else
                            {
                                search.ShowFileInGallery($(this));
                            }
                        })
                        .addClass("dn-event-click");

                        $('.dn-search-result a:not(.dn-event-click)').click(function(e) 
                        {
                            $searchResult = $(this).parents("div.dn-search-result");

                            // Get an array of the required badges from the data-required-badges attribute
                            var requiredBadges = String($searchResult.data('required-badges') || '')   // guarantee we’re working with text
                            // "1,2,3" → ["1","2","3"]
                            .split(',')
                            // drop empty pieces *and* non‑digits
                            .filter(function (token) 
                            {   
                                return /^\d+$/.test(token);
                            })
                            .map(function (token) 
                            {   
                                // convert to integers
                                return parseInt(token, 10);
                            });

                            var missingBadges = dn.user.GetMissingBadges(requiredBadges);

                            // Check to see if the user has all the required badges
                            if (missingBadges.length > 0)
                            {
                                e.preventDefault();     // don't let the link click work
                                dn.ShowBadgeModal(missingBadges, "to view this discussion", "", $searchResult.hasClass("dn-search-result accessible") ? "" : "<blockquote><b>NOTE:</b> You will need a <a href=\"/billing\">Premium subscription</a> to see this search result, regardless of whether you earn this badge.</blockquote>");
                            }
                            else if ($searchResult.hasClass("not-accessible"))
                            {
                                // This is a message that is inaccessible from a search result
                                e.preventDefault();     // don't let the link click work
                                dn.PromptToUpgrade("CanSearch");
                            }
                            
                            e.stopPropagation();    // don't let this bubble up
                        })
                        .addClass("dn-event-click");

                        $('span.dn-stream-downvoted:not(.dn-stream-downvoted-click)').click(function(e) 
                        {
                            e.preventDefault(); // stop the link click
                            e.stopPropagation();    // don't let this bubble up

                            dn.ShowDownvotedModal($(this));
                        })
                        .addClass("dn-stream-downvoted-click");
                    });
                },
                methods: 
                {
                    /**
                     * Set the search filters and load a fresh set of results.
                     */
                    fetch: function(deferToCheckboxes) 
                    {
                        $("#dn-search-filter-button").hide();
                        search.Vue.clear();
                        search.Vue.setSearchRequest(deferToCheckboxes);
                        search.Vue.loadMore();
                    },

                    /**
                     * Set the search request filters (search.Vue.SearchRequest).
                     * 
                     * @param {boolean} deferToCheckboxes - If true, we'll defer to filter checkboxes for the aggregates,
                     *                                   otherwise we'll use the querystring.
                     */
                    setSearchRequest: function (deferToCheckboxes) 
                    {
                        // Saving this here so we can refer to it in other parts of our search code.
                        var newKeywords = ($("#dn-search").val() || dn.QueryString.q || dn.QueryString.k || "");

                        if (!newKeywords || (search.Keywords && !dn.text.HasMatchingPrefix(search.Keywords, newKeywords, 1)))
                        {
                            // They are doing a search with no keywords (so they probably just cleared the search box),
                            // OR they are doing a search with new keywords and the first word of those keywords doesn't
                            // match the first word of the previous keywords, so let's just clear all the filters and 
                            // start over. 
                            //
                            // The idea here is that if someone is just adjusting _the end_ of their search keywords,
                            // then we'll keep the filters they had selected, but if they are changing the beginning
                            // of their search keywords, then we'll clear the filters and start over.
                            search.Vue.SearchRequest = 
                            {
                                // Keywords
                                q: newKeywords
                            };
                        }
                        else
                        {
                            // Otherwise we'll try to use any filters we find in the querystring or checked boxes
                            search.Vue.SearchRequest = 
                            {
                                // DateRangeEnd
                                dre: dn.QueryString.dre,
                                // DateRangeStart
                                drs: dn.QueryString.drs,
                                // Keywords
                                q: newKeywords,
                                // Makes
                                mk: dn.QueryString.mk,
                                // OutputFormat
                                o: dn.QueryString.o,
                                // Sort
                                s: dn.QueryString.s,
                                // VX on or off
                                vx: deferToCheckboxes 
                                    ? $("#dn-vx-ignore").is(":checked") ? 1 : 0
                                    : dn.QueryString.vx
                            };

                            dn.search.Aggregations.forEach
                            (
                                function(aggregation) 
                                {
                                    search.Vue.SearchRequest[aggregation.TypeShort] = $("#dn-agg-" + aggregation.Type + " input:checked").map(function() {return $(this).data("key")}).get();

                                    if (!deferToCheckboxes && search.Vue.SearchRequest[aggregation.TypeShort].length === 0 && dn.QueryString[aggregation.TypeShort])
                                    {
                                        if (aggregation.IsArray && !Array.isArray(dn.QueryString[aggregation.TypeShort]))
                                        {
                                            // It's a type that is supposed to be an array, but there was only one item in the querystring,
                                            // so we'll convert it to an array so that the server can handle it.
                                            search.Vue.SearchRequest[aggregation.TypeShort] = [dn.QueryString[aggregation.TypeShort]];
                                        }
                                        else
                                        {
                                            search.Vue.SearchRequest[aggregation.TypeShort] = dn.QueryString[aggregation.TypeShort];
                                        }
                                    }
                                }
                            );

                            if (deferToCheckboxes)
                            {
                                search.Vue.SearchRequest.vx = $("#dn-vx-ignore").is(":checked") ? "1" : "0";
                            }
                        }

                        search.Keywords = newKeywords;

                        dn.search.QueryString = dn.QueryStringFromJson(search.Vue.SearchRequest, "?");

                        // PageItemCount
                        search.Vue.SearchRequest.c = dn.constants.MaxResultsPerPage;
                        // PageStartIndex
                        search.Vue.SearchRequest.i = currentPage * dn.constants.MaxResultsPerPage;
                    },
                    /**
                     * Use the existing search filters, and load additional results.
                     */
                    loadMore: function () 
                    {
                        search.Vue.busy = true;

                        if (done || !search.Keywords) 
                        {
                            return;
                        }

                        numPageLoads++;

                        $.postJSON("/api/v1/search", search.Vue.SearchRequest)
                        .done(function (searchResult) 
                        {
                            if (searchResult)
                            {
                                search.NumHits += searchResult.Hits.length;
                                search.Vue.processSearchResult(searchResult, true);
                            }
                        })
                        .fail(function (xhr, textStatus, errorThrown) 
                        {
                            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                            {
                                // show an error to the user
                                search.Vue.addResult
                                ({
                                    Error: dn.search.Error.LoadingItems,
                                    Class:
                                    {
                                        Result: ""
                                    }
                                });
                            }
                        });
                    },
                    /**
                     * Process the search results, and update the UI accordingly.
                     * 
                     * @param {object} searchResult - The search results returned from the server.
                     * @param {boolean} saveState - If true, we'll save the state of the search results in history. If false, it's probably
                     *                             because we're re-rendering cached results from the state itself, and don't want to re-save.
                     */
                    processSearchResult: function (searchResult, saveState) 
                    {
                        if (saveState)
                        {
                            search.SaveState(searchResult);
                        }

                        console.debug("SearchResult", searchResult);

                        dn.tag.CurrentQueryKey = searchResult.QueryKey;

                        if (currentPage === 0)
                        {
                            search.Vue.Hits = [];
                            
                            // Loading results for the first time, not continuing from a scroll.
                            if (searchResult.VehiclesSimplified.length > 0)
                            {
                                var $el = $("#dn-search-metadata .dn-search-vehicles");

                                // Remove any existing vehicles
                                $el.empty();

                                // Show the user what vehicles were extracted from their input
                                searchResult.VehiclesSimplified.forEach
                                (
                                    function(simplifiedVehicle)
                                    {
                                        $el.append($('<div class="dn-metadata"><i class="fas fa-car"></i> <span>' + simplifiedVehicle + '</span></div>'));
                                    }
                                );

                                if (search.Vue.SearchRequest.vx == 0)
                                {
                                    $("#dn-vx-ignore").prop('checked', false);
                                    $("#dn-vx-description").css("opacity", 0.6);

                                    if (search.DisabledVX)
                                    {
                                        // Since this flag is set, it means the viewer actively turned off the 
                                        // VX suggestions for this search (and didn't just follow someone else's 
                                        // link that had vx disabled), so we're going to ask them why they disabled VX
                                        search.DisabledVX = false; // reset it for next time

                                        $("#dn-vx-feedback").show().addClass("animate__animated animate__heartBeat animate__delay-1s");
                                    }
                                    else
                                    {
                                        $("#dn-vx-feedback").hide().removeClass("animate__animated animate__heartBeat animate__delay-1s");
                                    }
                                }
                                else
                                {
                                    $("#dn-vx-ignore").prop('checked', true);
                                    $("#dn-vx-description").css("opacity", 1.0);

                                    $("#dn-vx-feedback").hide().removeClass("animate__animated animate__heartBeat animate__delay-1s");
                                }

                                $("#dn-search-metadata").show();

                                // Scroll to the left of the input box (in case there are a lot of keywords and it's gone off to the right)
                                //$("#dn-search").focus().scrollLeft(0);
                            }
                            else
                            {
                                $("#dn-search-metadata").hide();
                            }
                        }

                        if (searchResult.Hits.length > 0)
                        {
                            // Hide the "no results" message
                            $("#dn-no-search-results").hide();

                            // Show tools
                            $("#dn-search-tools").show();

                            var notAccessible = 0;
                            var accessible = 0;

                            searchResult.Hits.forEach
                            (
                                function(result)
                                {
                                    try 
                                    {
                                        if (result.Source.Link === null)
                                        {
                                            // The viewer is not able to access this document 
                                            result.Class = 
                                            {
                                                Result: "dn-search-result not-accessible"
                                            };

                                            notAccessible++;
                                        }
                                        else
                                        {
                                            // The viewer IS able to access this document
                                            result.Class = 
                                            {
                                                Result: "dn-search-result accessible"
                                            };

                                            accessible++;
                                        }

                                        result.Class.Result += " dn-engine-doctype-" + result.Source.Type;

                                        result.QueryKey = searchResult.QueryKey;

                                        result.Source.StatusName = dn.message.StatusReverse[(result.Source.Status || dn.message.Status.Default)];

                                        // If DateLastReplied is set/real, we'll show it in the tooltip
                                        result.DisplayDate = dn.FormatDateHtml(moment(result.Source.Date || result.Source.DateCreated).locale('en-short'));

                                        search.Vue.addResult(result);
                                    }
                                    catch (e) 
                                    {
                                        Sentry.captureException(e);

                                        try 
                                        {
                                            Sentry.captureMessage("Error in search results - cannot load result: " + result.DocumentKey + ". We showed an error to the user in the results, and attempted to continue displaying the other results.");
                                        } 
                                        catch (e2) 
                                        { 
                                            Sentry.captureException(e2); 
                                        }

                                        result = 
                                        {
                                            Error: dn.search.Error.RenderingItem,
                                            Class:
                                            {
                                                Result: ""
                                            }
                                        };

                                        search.Vue.addResult(result);
                                    }
                                }
                            );

                            // See if we should activate IsMixedAccessibility
                            if (search.IsMixedAccessibility || notAccessible > 0 && accessible > 0)
                            {
                                // Set our class so that we'll highlight accessible results
                                console.debug("ACTIVATING Mixed Accessibility", search.IsMixedAccessibility, notAccessible, accessible);
                                $("body").addClass("dn-search-mixed-accessibility");
                                search.IsMixedAccessibility = true; // so we'll remain here if they keep scrolling down the page
                            }
                            else
                            {
                                // Set our class so that we'll NOT highlight accessible results
                                console.debug("DEACTIVATING Mixed Accessibility", search.IsMixedAccessibility, notAccessible, accessible);
                                $("body").removeClass("dn-search-mixed-accessibility");
                            }

                            if (search.Vue.SearchRequest.i == 0) // PageStartIndex
                            {
                                // Show results metadata
                                $("#dn-search-results-metadata").html(dn.DecimalToString(searchResult.TotalHits, 0) + " results").attr('title', "Took " + dn.DecimalToString(searchResult.ElapsedMs / 1000, 2) + "s");
                            }
                        }
                        else if (search.Vue.SearchRequest.i == 0) // PageStartIndex
                        {
                            // No results and it's the initial query, not a scroll
                            $("#dn-no-search-results").show();

                            // Hide results metadata
                            $("#dn-search-results-metadata").html("").attr("title", "");

                            // Hide tools
                            $("#dn-search-tools").hide();
                        }

                        if (searchResult.Debug && searchResult.Debug.Error)
                        {
                            $("#dn-search-error").html(searchResult.Debug.Error).show();
                        }
                        else if (searchResult.Error)
                        {
                            $("#dn-search-error").html("Something bad happened! Try a new search?").show();
                        }
                        else
                        {
                            $("#dn-search-error").html("").hide();
                        }

                        if (dn.HasKeys(searchResult.Aggregations))
                        {
                            $("#dn-search-filters").empty();

                            // Iterate over each of our allowed aggregations
                            dn.search.Aggregations.forEach(function(aggregation) 
                            {
                                if (dn.HasKeys(searchResult.Aggregations[aggregation.Type]))
                                {
                                    // This agg exists in the results, let's append it.
                                    $("#dn-search-filters").append
                                    (
                                        '<div class="dn-search-agg dn-agg-collapsed mb-3" id="dn-agg-' + aggregation.Type + '" data-max-size="' + aggregation.MaxSize + '"><div class="dn-search-agg-title font-weight-bold mb-1">' + aggregation.Name + '</div><div class="dn-search-agg-values"></div></div>'
                                    );

                                    var totalChoices = 0;

                                    // Iterate over each of the agg results, and append them to the DOM
                                    Object.keys(searchResult.Aggregations[aggregation.Type]).filter(aggregation.Filter).sort(aggregation.Sort).forEach(function(key)
                                    {
                                        $("#dn-agg-" + aggregation.Type + ".dn-search-agg .dn-search-agg-values").append
                                        (
                                            '<div class="custom-control custom-checkbox dn-show-control">\
                                                <input type="checkbox" class="custom-control-input dn-search-agg-value" id="dn-agg-' + aggregation.Type + '-' + key + '" data-key="' + key + '"><label class="text-small custom-control-label clickable" for="dn-agg-' + aggregation.Type + '-' + key + '">' + 
                                                
                                                    aggregation.ValueLookup(key) + 
                                                    
                                                    '' + 

                                                '</label><span class="dn-agg-count">' + searchResult.Aggregations[aggregation.Type][key] + '</span>\
                                            </div>'
                                        );

                                        totalChoices++;
                                    });

                                    // Now let's see if SearchRequest had any values specified for this agg, and if so, check them
                                    if (search.Vue.SearchRequest[aggregation.TypeShort])
                                    {
                                        // We have some values specified in SearchRequest, so let's check them
                                        search.Vue.SearchRequest[aggregation.TypeShort].forEach(function(key)
                                        {
                                            $("#dn-agg-" + aggregation.Type + '-' + key).prop('checked', true);
                                        });
                                    }
                                    
                                    // Now let's see if we want to collapse any of the choices
                                    if (aggregation.MaxSize > 0)
                                    {
                                        // Add an "X More..." link if there are more than MaxSize choices
                                        var numHidden = totalChoices - aggregation.MaxSize;

                                        if (numHidden > 1) // only bother to hide MORE than 1 thing, otherwise the "X More..." link takes the same space
                                        {
                                            var $hideable = $("#dn-agg-" + aggregation.Type + " .custom-control:gt(" + (aggregation.MaxSize - 1) + "):has(input[type='checkbox']:not(:checked))");

                                            numHidden = $hideable.length;

                                            if (numHidden > 1)
                                            {
                                                $hideable.removeClass("dn-show-control");

                                                $("#dn-agg-" + aggregation.Type).append('<div class="dn-agg-expand dn-link dn-agg-collapsed" data-num-hidden="' + numHidden + '" id="dn-agg-expand-' + aggregation.Type + '">' + numHidden + ' More...</a>');

                                                $("#dn-agg-expand-" + aggregation.Type).on
                                                (
                                                    'click', 
                                                    search.AggregationExpand
                                                );
                                            }
                                        }
                                    }
                                }
                                else if (dn.HasKeys(search.Vue.SearchRequest[aggregation.TypeShort]))
                                {
                                    // Or this agg exists in the _request_ and we need to show it so they can turn it back off.
                                    $("#dn-search-filters").append
                                    (
                                        '<div class="dn-search-agg mb-3" id="dn-agg-' + aggregation.Type + '"><div class="dn-search-agg-title font-weight-bold mb-1">' + aggregation.Name + '</div><div class="dn-search-agg-values clickable"></div></div>'
                                    );

                                    search.Vue.SearchRequest[aggregation.TypeShort].forEach(function(key)
                                    {
                                        $("#dn-agg-" + aggregation.Type + ".dn-search-agg .dn-search-agg-values").append
                                        (
                                            '<div class="custom-control custom-checkbox">\
                                                <input type="checkbox" class="custom-control-input dn-search-agg-value" checked="checked" id="dn-agg-' + aggregation.Type + '-' + key + '" data-key="' + key + '"><label class="text-small custom-control-label" for="dn-agg-' + aggregation.Type + '-' + key + '">' + 
                                                
                                                    aggregation.ValueLookup(key) + 
                                                    
                                                    '' + 

                                                '</label><span class="dn-agg-count">0</span>\
                                            </div>'
                                        );
                                    });
                                }

                                if (document.querySelector("#dn-search-filters .custom-control-input:checked"))
                                {
                                    // There are some filters set, so make sure to show the filters
                                    $("#dn-search-tools").removeClass("collapsed");
                                }

                                $('#dn-agg-' + aggregation.Type).hover
                                (
                                    function() 
                                    {
                                        // Mouse enter
                                        var $parentDiv = $(this);

                                        // Expand all controls and change the link text to "Show Fewer..."
                                        $parentDiv.find('.custom-control').addClass("dn-show-control");
                                        $parentDiv.addClass("dn-agg-expanded").removeClass("dn-agg-collapsed");
                                        $parentDiv.find(".dn-agg-expand").hide();
                                    }
                                );
                            });

                            // If there are any checkboxes, show #dn-search-rotate-filter 
                            if ($("#dn-search-filters input[type=checkbox]").length > 0)
                            {
                                $("#dn-search-rotate-filter").show();
                            }
                            else
                            {
                                $("#dn-search-rotate-filter").hide();
                            }
                        }

                        // stop once there are zero hits for this particular page (this can happen if you remove search 
                        // results server-side without decrementing the found count), OR things unexpectedly somehow get 
                        // out of control and we have to force-stop the requests
                        done = (searchResult.Hits.length === 0 || numPageLoads > maxPageLoads);

                        currentPage++;
                        search.Vue.SearchRequest.i = currentPage * dn.constants.MaxResultsPerPage; // i == PageStartIndex

                        search.Vue.busy = false;
                    },
                    addResult: function (element) 
                    {
                        search.Vue.Hits.push(element);
                    },
                    clear: function () 
                    {
                        search.Vue.busy = true;
                        search.IsMixedAccessibility = false;
                        currentPage = 0;
                        search.NumHits = 0;
                        done = false;

                        search.Vue.busy = false;
                    }
                }
            }
        );

        Vue.component('search-result', 
        {
            props: ['result', 'vueIndex'],
            template: '\
                <div :class="result.Class.Result" :data-vue-index="vueIndex" :data-required-badges="result.Source.RequiredBadges">' + 

                    // Document Title
                    '<div class="dn-search-result-title"><a :href="dn.GetRedirectUrl(result.Source.Link, result.QueryKey)" class="dn-link" target="' + dn.constants.LinkTargetNewWindow + '">{{result.Source.Title}}</a>' + 
                    
                        // Votes, Replies, Date metadata
                        '<span class="float-right text-small text-secondary"><span v-if="result.Source.Votes != 0" class="homepage-votes mr-1" :class="{ \'dn-stream-downvoted\': result.Source.Votes < ' + dn.constants.ThresholdEngineVoteMinimum + '}" :data-userkey="result.Source.Author.AuthorKey" :data-isadmin="result.Source.Author.IsAdministrator" :data-ismanager="result.Source.Author.IsManager">{{result.Source.Votes}}<i v-if="result.Source.Votes > 0" class="fal fa-arrow-alt-up"></i><i v-if="result.Source.Votes < 0" class="fal fa-arrow-alt-down"></i></span><span v-if="result.Source.NumReplies > 0" class="homepage-comments mr-1">{{result.Source.NumReplies}}<i class="fal fa-comments-alt"></i></span><span class="dn-search-result-date" v-html="result.DisplayDate"></span></span>' + 
                        
                    '</div>' + 

                    // if (Community Discussion)
                    '<div class="dn-search-result-subheader" v-if="result.Source.Author">' +
                    
                        // Logged-in Member
                        '<template v-if="dn.user.IsLoggedIn && !result.Source.IsAnonymized"><img :src="result.Source.Author.Photo" class="dn-search-result-favicon">{{result.Source.Author.FirstName}} {{result.Source.Author.LastName}}, {{result.Source.Author.Position}} at <i>{{result.Source.Author.EmployerName}}</i> in {{result.Source.Author.Location}}</template>' + 

                        // Anonymous Viewer
                        '<template v-else><img :src="dn.constants.DataSources[result.Source.SourceKey].Icon" class="dn-search-result-favicon">{{result.Source.Author.FirstName}} in {{result.Source.Author.Location}}</template>' +

                    '</div>' +

                    // else if (OEM)
                    '<div class="dn-search-result-subheader" v-else-if="result.Source.Type === 2">' +

                        '<img :src="dn.constants.DataSources[result.Source.SourceKey].Icon" class="dn-search-result-favicon">{{dn.constants.DataSources[result.Source.SourceKey].Name}} / {{result.Source.Topics.join(" / ")}}' +

                    '</div>' + 

                    // else (All Other Documents)
                    '<div class="dn-search-result-subheader" v-else>' +

                        '<img v-if="dn.constants.DataSources[result.Source.SourceKey] && dn.constants.DataSources[result.Source.SourceKey].Icon" :src="dn.constants.DataSources[result.Source.SourceKey].Icon" class="dn-search-result-favicon"><img v-else src="' + dn.constants.UrlWebAssets + 'img/engine/globe-light.svg" class="dn-search-result-favicon"><a :href="dn.GetRedirectUrl(result.Source.Link, result.QueryKey)" class="clickable" target="' + dn.constants.LinkTargetNewWindow + '">{{result.Source.Link}}</a>' +

                    '</div>' + 

                    // Result Snippet
                    '<div class="dn-search-result-snippet" v-html="result.Source.Snippet"></div>' + 

                    // Metadata
                    '<div class="dn-tag-boxes mt-1">' +

                        // Type 
                        '<template v-if="result.Source.CommunityTypeId">' +
                        
                            // Closeable Type
                            '<a v-if="dn.constants.DiscussionTypes[result.Source.CommunityTypeId].IsCloseable" class="dn-type-link" :href="\'/\' + dn.constants.DiscussionTypes[result.Source.CommunityTypeId].TypeKey"><div class="dn-metadata dn-type-prefix">{{dn.constants.DiscussionTypes[result.Source.CommunityTypeId].Name}}</div><div class="dn-metadata dn-type-status" :style="{backgroundColor: (\'#\' + dn.message.StatusColorsPrimary[result.Source.Status] + \'22 !important\'), color: (\'#\' + dn.message.StatusColorsPrimary[result.Source.Status] + \' !important\')}"><span class="dn-type-status-text">{{dn.message.StatusVerbs[result.Source.Status]}}</span></div></a>' + 

                            // Non-Closeable Type
                            '<a v-else class="dn-type-link" :href="\'/\' + dn.constants.DiscussionTypes[result.Source.CommunityTypeId].TypeKey"><div class="dn-metadata dn-type">{{dn.constants.DiscussionTypes[result.Source.CommunityTypeId].Name}}</div></a>' +
                            
                        '</template>' + 

                        // (for OE SI) show Category instead of Type
                        '<div v-else-if="result.Source.Category" class="dn-metadata dn-type">{{result.Source.Category}}</div>' +

                        // Topics
                        '<template v-for="topic in result.Source.CommunityTopics"><a v-if="topic != dn.CurrentTopicId" :href="dn.constants.Topics[topic].LinkRelative" :data-topic-id="topic" class="dn-topic-link"><div class="dn-topic" :style="{backgroundColor: (dn.constants.Topics[topic].ColorPrimary + \'22\'), color: dn.constants.Topics[topic].ColorPrimary}"><span class="dn-topic-text"><i :class="dn.topic.GetIconClass(dn.constants.Topics[topic].Type)" data-toggle="tooltip" :title="dn.constants.TopicTypeNames[dn.constants.Topics[topic].Type]"></i> {{dn.constants.Topics[topic].Name}}</span></div></a></template>' +

                        // if (Vehicles Simplified), do those simplified vehicles... 
                        '<template v-if="result.Source.VehiclesSimplified.length">' + 
                            '<template v-for="vehicle in result.Source.VehiclesSimplified">' + 
                                '<div class="dn-metadata dn-simplified"><i class="fas fa-car"></i> <span v-html="vehicle"></span></div>' +
                            '</template>' +
                            // ...and optionally any non-Vehicles metadata
                            '<template v-if="result.Source.Metadata">' + 
                                '<template v-for="metadata in Object.keys(dn.constants.Metadata).map(function(metadataId) { return dn.constants.Metadata[metadataId]; }).filter(function(metadataItem) { return metadataItem.MetadataKey !== \'Vehicles\'; })">' +
                                    '<template v-if="result.Source.Metadata[metadata.MetadataKey]" v-for="item in result.Source.Metadata[metadata.MetadataKey]">' +
                                        '<div class="dn-metadata" data-toggle="tooltip" :title="metadata.Options.Render.ItemPopoverTemplate(item)"><i :class="metadata.Options.Render.Icon"></i> <span v-html="metadata.Options.Render.StreamBodyTemplate(item)"></span></div>' +
                                    '</template>' + 
                                '</template>' +
                            '</template>' + 
                        '</template>' +

                        // else (Metadata)
                        '<template v-else-if="result.Source.Metadata"><template v-for="metadata in Object.keys(dn.constants.Metadata).map(function(metadataId) { return dn.constants.Metadata[metadataId]; })"><template v-if="result.Source.Metadata[metadata.MetadataKey]" v-for="item in result.Source.Metadata[metadata.MetadataKey]"><div class="dn-metadata" data-toggle="tooltip" :title="metadata.Options.Render.ItemPopoverTemplate(item)"><i :class="metadata.Options.Render.Icon"></i> <span v-html="metadata.Options.Render.StreamBodyTemplate(item)"></span></div></template></template></template>\
                    </div>\
                    <div v-if="result.Source.Files && result.Source.Files.length" class="has-attachments dn-attachments clearfix">\
                        <div v-for="(file, index) in result.Source.Files" :id="file.FileKey" :data-fancybox-trigger="[\'gallery-\' + result.Source.DocumentKey]" :data-src="file.UrlEmbed" :data-filetype="file.Type" :data-type="(dn.HasFlag(file.Type, dn.constants.FileTypes.Image) ? \'\' : \'iframe\')" :class="[dn.HasFlag(file.Type, dn.constants.FileTypes.Video) ? \'dn-file-wrapper dn-gallery mr-1 mb-1 float-left video-thumbnail-overlay\' : \'dn-file-wrapper dn-gallery mr-1 mb-1 float-left\']"><img :src="file.UrlThumb" class="img-fluid rounded"/></div>\
                    </div>\
                </div>\
            '
        });

        // Perform the search if someone presses ENTER key in keyword box or with Apply Filters visible
        $(document).on('keydown', function(e) 
        {
            if (e.which === 13 & (e.target.id === 'dn-search' || $("div#dn-search-filter-button > button").is(":visible"))) 
            {
                search.Vue.fetch(true); // deferToCheckboxes == true, ignore querystring when deciding which filters to apply
                return false;
            }
        });

        // Perform the search if someone clicks the search button
        $("form#dn-search-filters").on
        (
            'click', 
            function(e)
            {
                if (e.target.type === 'checkbox') 
                {
                    $("#dn-search-filter-button").show();
                }
            }
        );

        // Wire up the "Apply Filters" button
        $("div#dn-search-filter-button > button").on
        (
            'click', 
            dn.search.Vue.fetch
        );

        // set the keyword input box based on `q` querystring
        $("#dn-search").val(search.Keywords || "");

        // run our initial search
        search.Vue.setSearchRequest();

        $('#dn-search').on('focus', function(e) 
        {
            // Force the cursor to the end of the input box, without selecting the text
            var val = e.target.value;
            e.target.value = '';
            e.target.value = val;
        });

        // put the focus in the search box, and then make sure the input is scrolled
        // all the way back to the left so that you can see the beginning of the string
        // todo: for now not doing the scroll-left, still investigating the ux here
        $("#dn-search").focus();//.scrollLeft(0);

        // toggle any popovers
        $('[data-toggle="popover"]').popover();
    };

    /**
     * As the user retrieves more results or performs new searches, we record/update the
     * state for the given URL, and then set or replace the state accordingly with history.
     * 
     * If we're not currently at the given URL, we'll push the new state onto history. If 
     * we're already at the same URL, we'll get the current state, append the new results,
     * and replaceState instead.
     * 
     * Elsewhere we're listening for `popstate` history events, and we re-render the view.
     */
    search.SaveState = function(searchResult)
    {
        console.debug("SaveState", "BEFORE", search.QueryString, history.state, searchResult);

        var newState = 
        {
            Keywords: search.Keywords,
            SearchRequest: search.Vue.SearchRequest
        };

        if (search.QueryString === document.location.search)
        {
            // Same querystring, replace state with new state
            if (history.state && history.state.SearchResult)
            {
                // merge new results, which means appending the new Hits
                newState.SearchResult = history.state.SearchResult;
                console.debug("SaveState", "APPENDING HITS", history.state.SearchResult.Hits.length, searchResult.Hits.length);
                newState.SearchResult.Hits = history.state.SearchResult.Hits.concat(searchResult.Hits);
            }
            else
            {
                newState.SearchResult = JSON.parse(JSON.stringify(searchResult));
            }

            console.debug("SaveState", "REPLACE", search.QueryString, newState.SearchResult.Hits.length, newState);
            history.replaceState(newState, document.title, search.QueryString);
        }
        else
        {
            // Querystring changed, so it's a new search... change the title and push new state to history
            console.debug("SaveState", "PUSH");
            newState.SearchResult = JSON.parse(JSON.stringify(searchResult));
            document.title = search.Keywords + " - " + dn.constants.CommunityName + " Search";
            history.pushState(newState, document.title, search.QueryString);
        }
    };

    /**
     * Sends search feedback, which currently just consists of tags indicating why they ignored VX.
     * This is patterned after dn.message.Tag(), in that both methods can be called by dn.tag.ShowTagger()
     * when saving tags.
     * 
     * @param {array} opt.tags          - Array of TagIds this user wants assigned to the given message.
     * @param {int} opt.tagEvent        - The event that led to this tag request, e.g. dn.tag.TagEvent.Upvote, 
     *                                    Downvote, or Bookmark.
     * @param {string} opt.queryKey     - Unique identifier for the search result that this feedback is about.
     * @param {func} opt.onSuccess      - Callback function we'll pass the message's tag info to.
     * @param {func} opt.onFailure      - (Optional) callback function we'll pass any failure info to.
     */
    search.SendFeedback = dn.Debounce(function(opt) 
    {
        var vehiclesSimplified = (history.state && history.state.SearchResult) 
            ? JSON.parse(JSON.stringify(history.state.SearchResult.VehiclesSimplified))
            : null;

        $.postJSON("/api/v1/feedback", 
        {
            Query: search.Vue.SearchRequest,
            QueryKey: opt.queryKey,
            Tags: opt.tags,
            TagEvent: opt.tagEvent,
            VehiclesSimplified: vehiclesSimplified
        })
        .done(function(tags) 
        {
            if (opt.onSuccess)
            {
                opt.onSuccess(tags);
            }
        })
        .fail(function(xhr, textStatus, errorThrown) 
        {
            if (opt.onFailure)
            {
                opt.onFailure(xhr, textStatus, errorThrown);
            }
        });

    }, 200, true); // execute immediately, but not again for at least 200 ms

    /**
     * View a file's details in full screen mode. If there are multiple files in a set, 
     * the user can scroll back and forth between them.
     * 
     * @param {element} element - Element they clicked on to initiate the gallery view.
     */
    search.ShowFileInGallery = function($element, extramessage)
    {
        if (!dn.user.IsLoggedIn) 
        {
            dn.PromptToLogin('view attachments');
        }
        else 
        {
            // Get the index of this message's backing data in search.Vue.Hits
            var vueIndex = $element.closest('.dn-search-result').data('vue-index');

            // if (vueIndex && search.Vue.Hits[vueIndex].IsAnonymized)
            // {
            //     // The user is logged in, but the message was anonymized, so they cannot view files from the message.
            //     // The only scenario where this should be able to happen is viewing a closed message that's anonymized.
            //     // So find out what the TopicId is of the closed group, and prompt them to subscribe to it if found.
            //     var closedGroupIndex = search.Vue.Hits[vueIndex].TopicTypes.findIndex
            //     (
            //         function(element, index, array)
            //         {
            //             return (element == dn.constants.TopicType.ClosedGroup);
            //         }
            //     );

            //     if (closedGroupIndex > -1 && search.Vue.Hits[vueIndex].Topics.length > closedGroupIndex)
            //     {
            //         // They are trying to view attachments in a message posted to a closed/private group that they aren't subscribed to
            //         dn.PromptToSubscribe(search.Vue.Hits[vueIndex].Topics[closedGroupIndex], 'view attachments', function(e) { dn.ShowFileInGallery($element, extramessage); });
            //     }
            //     else
            //     {
            //         // This should never happen, but will show a generic error if so.
            //         dn.ShowModal({ title: "Problem Viewing File", body: "<p>There was a problem viewing this file.</p>" + (extramessage || '') });
            //     }

            //     return;
            // }

            var filetype = parseInt($element.data('filetype'));

            if ((filetype & dn.constants.FileTypes.AwaitingConversion) != 0) 
            {
                var file = ((filetype & dn.constants.FileTypes.Video) != 0) ? "Video" : (((filetype & dn.constants.FileTypes.Audio) != 0) ? "Audio" : "File");
                dn.ShowModal({ title: file + " Processing In Progress", body: "<p>We're currently processing the file, which may take a few minutes.</p>" + (extramessage || '') });
            }
            else
            {
                $.fancybox.open
                (
                    $('[data-fancybox-trigger="' + $element.data('fancybox-trigger') + '"]'), 
                    {
                        animationDuration: 200,
                        transitionEffect: "slide",
                        transitionDuration: 300,
                        iframe: 
                        {
                            preload: true
                        },
                        afterLoad: function(instance, current) 
                        {
                            if (dn.Windows[current.src])
                            {
                                dn.ResizeIframe(current.src, dn.Windows[current.src]);
                            }                            
                        }
                    }, 
                    $element.index()
                );
            }
        }
    };

    $(document).ready
    (
        function ($)
        {
            // Process any queued functions now that the namespace is ready.
            dn.ProcessQueuedFunctions('dn.search');
        }
    );

}(window.dn.search = window.dn.search || {}, jQuery));